import { type QueryClient } from '@tanstack/react-query';
import { type RouteObject } from 'react-router-dom';

import { firstAllowed, requirePermissions } from '@/app/requirePermissions';
import { PagePermissions } from '@/models/pagePermissions';

export const transactionsRoute = (queryClient: QueryClient): RouteObject => ({
  path: 'transactions',
  children: [
    {
      path: '',
      loader: firstAllowed([
        { to: 'store', oneOf: PagePermissions.transactionsStore },
        { to: 'inventory', oneOf: PagePermissions.transactionsInventory },
      ]),
    },
    {
      path: 'store',
      // On the parent, so the child keeps its own data loader untouched.
      loader: requirePermissions({ oneOf: PagePermissions.transactionsStore }),
      children: [
        {
          index: true,
          lazy: async () => {
            const { loader, Component } = await import('./store');
            return { loader: loader(queryClient), Component };
          },
        },
      ],
    },
    {
      path: 'inventory',
      // On the parent, so the child keeps its own data loader untouched.
      loader: requirePermissions({
        oneOf: PagePermissions.transactionsInventory,
      }),
      children: [
        {
          index: true,
          lazy: async () => {
            const { loader, Component } = await import('./inventory');
            return { loader: loader(queryClient), Component };
          },
        },
      ],
    },
  ],
});
